<!-- StepProgress.vue -->
<template>
    <div class="modal_main_progres" :class="progressClass">
      <!-- Круглый прогресс -->
      <div class="progress-container" v-if="!isComplete">
        <svg width="246" height="246" viewBox="0 0 120 120">
          <defs>
            <linearGradient id="gradient" x1="1" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#8A75FF" />
              <stop offset="100%" stop-color="#FF3A99" />
            </linearGradient>
          </defs>
          <circle class="track" cx="60" cy="60" r="50" stroke-width="5" fill="none" />
          <circle class="progress" :stroke-dasharray="circumference"
            :stroke-dashoffset="progressOffset" cx="60" cy="60" r="50" stroke-width="5"
            stroke="url(#gradient)" fill="none" stroke-linecap="round" />
          <text x="60" y="65" text-anchor="middle" font-size="15" fill="white">
            {{ percentage }}%
          </text>
        </svg>
      </div>
  
      <!-- Результат проверки -->
      <div class="modal_main_analysis_head modal_main_analysis_head_v2" v-if="!isRejected && isComplete">
        <div class="head_logo">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"
            fill="none" stroke="oklch(.792 .209 151.711)" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
            <path d="m9 11 3 3L22 4"></path>
          </svg>
        </div>
        <br>
        <h1>{{ title }}</h1>
        <br>
        <br>
        <div>{{ message }}</div>
        <br>
        <br>

        <div class="progress-container_table" v-if="showSections && sections.length">
          <h3>Найденные разделы</h3>
          <div class="progress-container_table_one progress-container_table_one_v2" 
              v-for="(section, index) in sections" 
              :key="index">
            <span v-if="checklist[index + 1]">  <!-- показываем только если true -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="oklch(.792 .209 151.711)" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                <path d="m9 11 3 3L22 4"></path>
              </svg>
            </span>
            <span style="margin-left: 5px;" v-if="!checklist[index + 1]">  <!-- показываем только если true -->
              ❌
            </span>
            {{ section }}
          </div>
        </div>
  
        <br>
        <br>
        <div class="modal_main_load_content_btn" @click="$emit('continue')" style="cursor: pointer;">
          <span>Продолжить</span>
        </div>
      </div>




      <div class="progress-container_one_errore" v-if="isRejected && isComplete">
                        <div class="progress-container_one_errore_head">
                          Проверка типа документа не пройдена. Похоже, это не регламент.
                        </div>

                        <div class="progress-container_one_errore_block">
                            <div v-for="e in FAQ" :key="e" class="progress-container_one_errore_element">
                                <div class="progress-container_one_errore_element_icon">{{ e.icon }}</div>
                                <div class="progress-container_one_errore_element_head">{{ e.head }}</div>
                                <div class="progress-container_one_errore_element_text">{{ e.text }}</div>

                            </div>
                        </div>
                        <br>
                        <br>
                        <a target="_blank" href="https://ai-lazarus.com/static/structure_ru.pdf"
                                style="padding: 21px;align-items: center;"
                                class="modal_main_load_content_btn"
                                >
                                <svg style="transform: none;" width="25" height="24" viewBox="0 0 25 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12.3333 16L7.33325 11L8.73325 9.55L11.3333 12.15V4H13.3333V12.15L15.9333 9.55L17.3333 11L12.3333 16ZM6.33325 20C5.78325 20 5.31242 19.8042 4.92075 19.4125C4.52909 19.0208 4.33325 18.55 4.33325 18V15H6.33325V18H18.3333V15H20.3333V18C20.3333 18.55 20.1374 19.0208 19.7458 19.4125C19.3541 19.8042 18.8833 20 18.3333 20H6.33325Z"
                                        fill="white" />
                                </svg>
                                <span>Скачать эталонный регламент</span>
                            </a>
                    </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StepProgress',
    props: {
      checklist: {
        type: Object,
        default: () => ({})
      },
      isRejected: {
        type: Boolean,
        default: false
      },
      percentage: {
        type: Number,
        default: 0
      },
      circumference: {
        type: Number,
        required: true
      },
      progressOffset: {
        type: Number,
        required: true
      },
      isComplete: {
        type: Boolean,
        default: false
      },
      documentInfo: {
        type: Object,
        default: null
      },
      showSections: {
        type: Boolean,
        default: false
      },
      sections: {
        type: Array,
        default: () => []
      },
      title: {
        type: String,
        default: 'Документ успешно распознан'
      },
      message: {
        type: String,
        default: 'Ваш файл соответствует структуре регламента'
      },
      progressClass: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        FAQ: [
                    {
                        icon: '📄',
                        head: 'Что такое регламент',
                        text: 'Это официальный документ, описывающий конкретный бизнес-процесс: цель, роли, последовательность действий, входы и выходы, метрики контроля.'
                    },
                    {
                        icon: '🏷️',
                        head: 'Ключевые признаки',
                        text: 'В первых страницах встречаются термины «регламент», «стандарт процесса», «положение о процессе», «процедура» и чёткое описание порядка взаимодействия подразделений и сотрудников.'
                    },
                    {
                        icon: '❌',
                        head: 'Чего мы не нашли',
                        text: 'В загруженном файле отсутствует раздел о взаимодействии участников процесса, нет описания ролей и шагов — поэтому документ не распознан как регламент.'
                    },
                    {
                        icon: '✏️',
                        head: 'Что сделать',
                        text: 'Загрузите документ, который фиксирует порядок действий внутри процесса, либо скачайте наш эталонный шаблон — он поможет быстро оформить регламент корректно.'
                    },
                ],
      }
    },
  }
  </script>
  
  <style scoped>
  .modal_main_progres {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 400px;
  }
  
  .progress-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 246px;
    height: 246px;
  }
  
  .track {
    stroke: #2c2c2c;
  }
  
  .progress {
    transform: rotate(-90deg);
    transform-origin: center;
    transition: stroke-dashoffset 0.5s ease;
  }
  
  .modal_main_analysis_head_v2 {
    padding: 32px 16px;
    border-radius: 23px;
    border: 1px solid #403F6D;
    width: 100%;
    max-width: 600px;
  }
  
  .head_logo {
    display: flex;
    justify-content: center;
  }
  
  .progress-container_table {
    background: #ffffff0a;
    border-radius: 16px;
    padding: 16px;
  }
  
  .progress-container_table_one,
  .progress-container_table_two,
  .progress-container_table_tree {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #ffffff1a;
  }
  
  .progress-container_table_one:last-child,
  .progress-container_table_two:last-child,
  .progress-container_table_tree:last-child {
    border-bottom: none;
  }
  
  .progress-container_table_one_v2 {
    justify-content: flex-start;
    gap: 16px;
    align-items: center;
    border-bottom: 1px solid #ffffff1a;
  }
  
  .progress-container_table_one_v2:last-child {
    border-bottom: none;
  }
  
  .progress-container_table_one_v2 span {
    flex-shrink: 0;
  }
  
  .modal_main_load_content_btn {
    display: flex;
    gap: 8px;
    width: 100%;
    padding: 18px 40px;
    background: #8A75FF;
    justify-content: center;
    border-radius: 24px;
    max-width: 740px;
    cursor: pointer;
    margin: 0 auto;
  }
  
  h3 {
    margin: 0 0 16px 0;
    text-align: left;
  }
  
  h1 {
    margin: 0;
    font-size: 24px;
  }
  .progress-container_one_errore_head {
    text-align: start;
    margin-bottom: 32px;
    @media (max-width: 520px) {
        font-size: 13px;
    }
}

.progress-container_one_errore_block {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    /* пространство между элементами */
    flex-wrap: wrap;

    @media (max-width: 850px) {
        grid-template-columns: repeat(1, 1fr);
        max-height: 70%;
        overflow-y: scroll;
        margin: 4px 0;
    }
}

.progress-container_one_errore_element {
    background: #ffffff10;
    padding: 24px;
    border-radius: 24px;
    box-sizing: border-box;
    /* NEW: выравниваем все блоки по высоте */
    height: 100%;
    text-align: start;
    position: relative;
    padding-left: 66px;

    @media (max-width: 850px) {
        height: auto;
        padding: 12px;
        border-radius: 12px;
        padding-left: 42px;
    }

}

.progress-container_one_errore_element_icon {
    position: absolute;
    left: 24px;
    top: 24px;

    @media (max-width: 850px) {
        left: 12px;
        top: 12px;
    }
}

.progress-container_one_errore_element_head {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 8px;

    @media (max-width: 850px) {
        font-size: 13px;
    }
}

.progress-container_one_errore_element_text {
    color: #888888;
    font-weight: 400;

    @media (max-width: 850px) {
        font-size: 12px;
    }
}

.progress-container_one_errore_block_btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    @media (max-width: 520px) {
        flex-direction: column;
    }

}

.progress-container_one_errore_block_btns_one {
    background: #8A75FF;
    border: 1px solid transparent;

    @media (max-width: 850px) {
        padding: 9px !important;
        font-size: 12px;
    }
}
  </style>